import api from '..';
import mutationFactory from './mutationFactory';

const createMutation = mutationFactory({});

export const useReindex = createMutation(api.indexer.reindex);
